export default __webpack_public_path__ + "static/media/website-logo.64f60e79.png";